@if (ready) {
  <div class="persona-picker">
    @if (selfProfile) {
      <div class="self-profile">
        <se-po-persona-choice
          [profile]="selfProfile"
          [profileFrame]="getProfileFrame(selfProfile)"
          [requiredFields]="getRequiredFieldsForProfile(selfProfile)"
          (chosen)="onPick($event)"
          (edit)="onEdit($event)"
          (action)="onAction($event)"
          (editMissingInfo)="onEditMissingInfo($event)"
        ></se-po-persona-choice>
      </div>
    }
    @if (managedProfiles && managedProfiles.length) {
      <div class="child-profiles">
        <h4>{{ 'SE_PO_UI_PERSONA_PICKER.CHILD_PROFILES' | translate }}</h4>
        @for (profile of managedProfiles; track profile) {
          <se-po-persona-choice
            [profile]="profile"
            [requiredFields]="getRequiredFieldsForProfile(profile)"
            [profileFrame]="getProfileFrame(profile)"
            (chosen)="onPick($event)"
            (edit)="onEdit($event)"
            (action)="onAction($event)"
            (editMissingInfo)="onEditMissingInfo($event)"
          ></se-po-persona-choice>
        }
      </div>
    }
  </div>
}
